import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ImageComponent from '../ImageComponent/ImageComponent';
import styles from './EntryPageTemplate.module.scss';

function EntryPageTemplate(props) {
    // TDIC: isWideContent added
    const {
        applicationName,
        applicationLogo,
        contentToRender,
        isWideContent
    } = props;
    return (
        <Fragment>
            <div id="entryPageTemplate" className={styles.entryPageTemplate}>
                <div id="entryPageTemplateHeader" className={styles.entryPageTemplateHeader}>
                    <div id="entryPageTemplateLogo" className={styles.entryPageTemplateLogo}>
                        <ImageComponent src={applicationLogo} title={applicationName} />
                    </div>
                </div>
                <div
                    id="entryPageTemplateContent"
                    className={
                        `${isWideContent ? styles.entryPageTemplateContentVariablesWide : styles.entryPageTemplateContentVariables}
                        ${styles.entryPageTemplateContent}`
                    }
                >
                    <div
                        id="entryPageContentContainer"
                        className={styles.entryPageContentContainer}
                    >
                        {contentToRender}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
EntryPageTemplate.propTypes = {
    applicationName: PropTypes.string.isRequired,
    applicationLogo: PropTypes.string.isRequired,
    contentToRender: PropTypes.shape({}).isRequired,
    // TDIC: isWideContent PropTypes added
    isWideContent: PropTypes.bool
};
// TDIC: EntryPageTemplate.defaultProps added
EntryPageTemplate.defaultProps = {
    isWideContent: false
};

export default EntryPageTemplate;
